export default "__VITE_ASSET__DuHBINIG__"